<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Logs</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>

        <v-card style="max-width:100%; position:relative">
          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :options.sync="options"
              :sort-by="['time']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
              <td class="no-break">{{ item.time | datetime}}</td>
              <td >{{ item.userId }}</td>
              <td >{{ item.role }}</td>
              <td >{{ item.method }}</td>
              <td >{{ item.url }}</td>
              <td >{{ item.body }}</td>
              </tr>
              </tbody>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  export default {
    data () {
      return {
        form: {},
        menu: false,
        menu2: false,
        time: null,
        date: null,
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        search: '',
        options: {},
        selectedItem: {},
        headers: [
          {
            text: 'Time',
            align: 'left',
            sortable: true,
            value: 'time'
          },
          { text: 'User', value: 'userId' },
          { text: 'Role', value: 'role' },
          { text: 'Method', value: 'metod' },
          { text: 'url', value: 'urls' },
          { text: 'Body', value: 'body' }
        ],
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onClose () {
        this.dialog = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getData();
      },
      onUpdate (data) {
        console.log('save update booking: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/destination', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.reset();
          this.getData();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      deleteItem (id) {
        this.$http
        .delete('api/logs/' + id)
        .then(response => {
          console.log('logs deleted', response.data);
          this.getData();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getData () {
        var app = this;
        this.$http
        .get('api/logs')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
    }
  }
</script>

<style lang="scss">
  .no-break {
    white-space: nowrap;
  }
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









